(function () {
  'use strict';
  function initialize() {
    document.querySelectorAll('[data-benefits-art]').forEach(function (art) {
      if (art.dataset.ready) return;
      var pairs = ['tokyo', 'chanel', 'mela'];
      var pair = 'tokyo';
      try {
        pair = sessionStorage.getItem('vikis-benefits-approved-pair');
        if (pairs.indexOf(pair) === -1) {
          pair = pairs[Math.floor(Math.random() * pairs.length)];
          sessionStorage.setItem('vikis-benefits-approved-pair', pair);
        }
      } catch (_) { pair = 'tokyo'; }
      // An explicit review URL chooses one static set; normal visits use their saved choice.
      var reviewPair = new URLSearchParams(location.search).get('vikis_benefits_preview');
      if (pairs.indexOf(reviewPair) !== -1) pair = reviewPair;
      var img = art.querySelector('img');
      if (pair !== 'mela') {
        art.querySelector('source').srcset = art.dataset[pair + 'Mobile'];
        img.src = art.dataset[pair + 'Desktop'];
      }
      img.alt = pair === 'mela'
        ? 'Mela in the larger organic frame, with Coco in the smaller overlapping frame. Both pets are named.'
        : pair === 'chanel'
        ? 'Chanel in the larger organic frame, with Hanan in the smaller overlapping frame. Both pets are named.'
        : 'Tokyo in the larger organic frame, with Malleeseh cuddling in the smaller overlapping frame. Both pets are named.';
      art.dataset.pair = pair;
      art.dataset.ready = 'true';
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
